
export default {

    getSteps(state){
        return state.steps;
    },
    getCriteria(state){
        return state.criteria;
    },
    getCriterionGroup: state => groupId => {
        return state.criteria.filter((criterion) => criterion.criterionGroup === groupId);
    },
    getActiveStep(state){
        return state.steps.find((step)=> step.active)
    },
    getActiveStepIndex(state){
        return state.steps.findIndex((step)=> step.active)
    },

    getUnvalidateCriteria: state => stepIndex => {
        if(!stepIndex) stepIndex = state.steps.findIndex((step)=> step.active);

        let passedSteps = [];
        for(let i = 0; i <=stepIndex;i++){
            passedSteps.push(state.steps[i].id);
        }
        const passedStepsCriteria = state.criteria.filter((crirerion) => passedSteps.includes(crirerion.stepId));
        return passedStepsCriteria.filter((criteria) => criteria.unvalid);

    },
    getLastValidStep(state, getters){
     const unvalidateCriteria = getters.getUnvalidateCriteria();
     if(unvalidateCriteria.length){
         const stepId = unvalidateCriteria[0].stepId;
         const stepIndex = state.steps.findIndex(step => step.id === stepId);
         window.console.log(stepIndex)
         if(stepIndex !== -1){
             return stepIndex;
         }else{
             return state.steps.findIndex(step => step.validClass === 'step-has-errrors')
         }

     }else{
         return getters.getActiveStepIndex+1
     }

    },
    getProducts(state){
        return state.products;
    },
    getProductsType(state){
        return state.products.length ? state.products[0]['heating_type'] : 'heating_cable'
    },
    getSelectedCriteria(state){
      return state.selectedCriteria;
    },
    getSelectedFlooringTypeText(state){
        const selectedName = state.selectedCriteria.flooring_type;
        const criterionData = state.criteria.find(i => i.name === 'flooring_type').values.find(i => i.value === selectedName);
        return criterionData['textWhom'] ? criterionData['textWhom'] : ''
    },
    getCartTotal(state){
        if(!state.products.length) return 0;
        return Math.round(state.products.reduce((res, cur) => cur.inCart ? (res + (cur.price + (cur.complect ? cur.complect.price : 0))) : res, 0));

    },
    getCartProducts(state){
        return state.products.filter((product) => product.inCart);
    },
    getActiveMode(state){
        return state.mode;
    }
}